
export const FETCH_USER = 'fetch_user';

export const FETCH_SCREEN_HOME = 'fetch_screen_home';
export const FETCH_SCREEN_DONOR_PROFILE = 'fetch_screen_donor_profile';
export const FETCH_SCREEN_FAILED = 'fetch_screen_failed';

export const PROJECT = 'project';
export const PROJECTS = 'projects';

export const CHARITY = 'charity';
export const CHARITIES = 'charities';

export const PAYMENTS_SUCCESS = 'payments_success';
export const PAYMENTS_FAILED = 'payments_failed';

export const FILTERED_SEARCH_SUCCESS = 'filtered_search_success';
export const FILTERED_SEARCH_FAILED = 'filtered_search_failed';
export const FILTERS_UPDATE = 'filters_update';
export const FILTERS_FAILED = 'filters_failed';

export const FAVOURITE_SUCCESS = 'favourite_success';
export const FAVOURITE_FAILED = 'favourite_failed';

export const CATEGORIES = 'categories';

export const CONTINUEREF = 'continueref';



// WEBPACK FOOTER //
// ./src/actions/types.js